import perfiosLogo from '../assests/images/perfios.png';
import wellsLogo from '../assests/images/wellsfargo.png';

export const timelineData = [
  {
    startdate: "2025 Nov - ",
    enddate: "Present",
    company: {
      name: "Wells Fargo",
      url: "https://www.wellsfargo.com/",
      logo: wellsLogo
    },
    role: "Software Engineer",
    responsibilities: [
      "Contributed extensively to a data platform supporting 300+ production data pipelines, working with Apache Airflow for orchestration, dynamic DAGs, scheduling, dependency management, and production troubleshooting.",
      "Enhanced dynamic Airflow DAGs and reusable pipeline frameworks, implementing new capabilities and improving the reliability and maintainability of large-scale data workflows.",
      "Developed and enhanced PySpark-based data ingestion and transformation pipelines processing GBs of data per day across multiple upstream and downstream systems.",
      "Worked on Apache Iceberg-based data workflows, supporting ingestion of data from multiple source systems into Iceberg catalogs and egress of cataloged datasets to downstream consumers.",
      "Developed and enhanced Django-based REST APIs and backend components supporting internal platform functionality and integrations."
    ]
  },

  {
    startdate: "2023 Sep - ",
    enddate: "2025 Nov",
    company: {
      name: "Perfios Software Solutions Pvt Ltd",
      url: "https://www.perfios.com/index.php",
      logo: perfiosLogo
    },
    role: "Software Development Engineer (Backend)",
    responsibilities: [
      "Designed and implemented a scalable distributed backend for SDK activity monitoring and financial fraud detection, leveraging AWS ECS for container orchestration and Kafka for event-driven communication to handle over 1M requests per day.",
      "Developed and optimized backend APIs and data ingestion services, enabling reliable data flow across microservices and integration with multiple internal systems.",
      "Conducted load testing and performance profiling of critical APIs, resolving bottlenecks through MongoDB query optimization, strategic indexing, and multi-tier caching using Redis and in-memory caching, reducing API latency by 30--40%.",
      "Built observability and monitoring infrastructure using the ELK Stack for API metrics and Grafana for Kafka performance monitoring through JMX metrics, improving visibility into service health and production issues.",
      "Engineered PySpark data pipelines processing 1M+ records per day to generate precomputed aggregations, accelerating downstream API responses and enhancing large-scale fraud detection workflows."
    ]
  },

  {
    startdate: "2023 Feb - ",
    enddate: "2023 Aug",
    company: {
      name: "Perfios Software Solutions Pvt Ltd",
      url: "https://www.perfios.com/index.php",
      logo: perfiosLogo
    },
    role: "Software Development Engineer Intern (Backend)",
    responsibilities: [
      "Designed and implemented an event-driven architecture for the Footprint API, enabling verification of email and mobile number presence on the platform through 50+ crawlers, leveraging AWS Lambda and SQS for scalable and reliable execution.",
      "Developed Python-based backend APIs for crawler management and data collection, integrating AWS Lambda with API Gateway for serverless execution and endpoint management.",
      "Built data ingestion pipelines to process and store crawler results in backend systems, ensuring reliable data flow and integration with existing microservices."
    ]
  }
];